
export const TaskStatuses = {
  OPEN: 'Solicitado',
  QUOTED: 'Presupuestado',
  SCHEDULED: 'Programado',
  ONGOING: 'En Curso',
  COMPLETED: 'Completado',
  INVOICED: 'Facturado',
  CANCELLED: 'Cancelado',
}

export const TaskStatusesFilterOptions = { ...TaskStatuses, ACTIVE: 'No Cancelado' }

// export const TaskPhasesCommonRelated = ['CANCELLED'];
export const TaskStatusRelated = {
  OPEN: ['QUOTED', 'SCHEDULED'],
  QUOTED: ['SCHEDULED'],
  SCHEDULED: ['ONGOING', 'COMPLETED'],
  ONGOING: ['COMPLETED'],
  COMPLETED: [],
  INVOICED: [],
  CANCELLED: [],
}

export const Week: any = {
  SU: 'Dom',
  MO: 'Lun',
  TU: 'Mar',
  WE: 'Mié',
  TH: 'Jue',
  FR: 'Vie',
  SA: 'Sáb',
}


export const TaskInvoicingFrequencies = {
  MONTHLY: 'Mensualmente (ultimo dia del mes)',
  VISIT: 'Por Visita',
  COMPLETED: 'Completado'
}